/*
  TASK-2237 — "Chat with us" placeholder popup.
  TASK-2241 — copy fix (no em-dash, no WhatsApp line) + close only via OK.

  The footer chat CTA (see custom-footer.liquid, class .ils-footer__chat,
  data-ils-chat-trigger) currently has no working chat behind it. Until a
  real chat widget is wired up, clicking the CTA shows a lightweight
  modal that explains the situation. Owner directive (TASK-2241):
    - drop the em-dash — split into two sentences instead
    - drop the WhatsApp fallback line entirely
    - the OK button is the ONLY way to dismiss (no overlay / no Esc / no X)

  Locale strings are painted client-side, matching the pattern used by
  custom-preorder-popup.js — no Shopify Translate keys required.

  Locales covered: en, ru, de, lv, et, lt (6 storefront languages).
*/
(function () {
  var LOCALE_STRINGS = {
    en: {
      title: 'Live chat coming soon',
      lines: [
        'Our live chat is still being set up and tested. It isn’t available just yet.',
        'We’ll email you as soon as it goes live.'
      ],
      ok: 'OK'
    },
    ru: {
      title: 'Онлайн-чат скоро появится',
      lines: [
        'Мы ещё настраиваем и тестируем онлайн-чат. Пока он недоступен.',
        'Мы сообщим вам по email, как только он заработает.'
      ],
      ok: 'OK'
    },
    de: {
      title: 'Live-Chat bald verfügbar',
      lines: [
        'Unser Live-Chat wird gerade eingerichtet und getestet. Er ist noch nicht verfügbar.',
        'Wir informieren Sie per E-Mail, sobald er online ist.'
      ],
      ok: 'OK'
    },
    lv: {
      title: 'Tiešsaistes čats drīzumā',
      lines: [
        'Mūsu tiešsaistes čats vēl tiek uzstādīts un testēts. Pagaidām tas nav pieejams.',
        'Mēs paziņosim jums e-pastā, tiklīdz tas būs pieejams.'
      ],
      ok: 'Labi'
    },
    et: {
      title: 'Live-vestlus tuleb varsti',
      lines: [
        'Meie live-vestlust alles seadistatakse ja testitakse. See pole veel saadaval.',
        'Anname e-kirjaga teada, kui see on kasutamiseks valmis.'
      ],
      ok: 'Selge'
    },
    lt: {
      title: 'Tiesioginis pokalbis netrukus',
      lines: [
        'Mūsų tiesioginio pokalbio langas dar tvarkomas ir testuojamas. Kol kas nepasiekiamas.',
        'Kai tik jis veiks, pranešime jums el. paštu.'
      ],
      ok: 'Gerai'
    }
  };

  function currentLocale() {
    var raw = (window.ILS_LANG || (window.Shopify && Shopify.locale) || document.documentElement.lang || 'en') + '';
    raw = raw.toLowerCase().split('-')[0];
    return LOCALE_STRINGS[raw] ? raw : 'en';
  }

  var modal = null;
  var lastFocused = null;

  function ensureModal() {
    if (modal) return modal;
    modal = document.getElementById('ils-chat-placeholder-modal');
    return modal;
  }

  function paint() {
    var m = ensureModal();
    if (!m) return false;
    var loc = LOCALE_STRINGS[currentLocale()];
    m.querySelector('[data-ils-chat-title]').textContent = loc.title;
    var body = m.querySelector('[data-ils-chat-body]');
    body.innerHTML = loc.lines.map(function (line) { return '<p>' + line + '</p>'; }).join('');
    m.querySelector('[data-ils-chat-ok]').textContent = loc.ok;
    return true;
  }

  function open() {
    if (!paint()) return;
    lastFocused = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var okBtn = modal.querySelector('[data-ils-chat-ok]');
    if (okBtn) setTimeout(function () { okBtn.focus(); }, 0);
  }

  function close() {
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try { lastFocused.focus(); } catch (e) {}
    }
    lastFocused = null;
  }

  // Delegate the trigger click off the document so the CTA can be
  // re-rendered by Shopify's section reload without losing the binding.
  // Per TASK-2241 the ONLY dismiss path is the OK button — no backdrop /
  // no Esc / no X.
  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest && e.target.closest('[data-ils-chat-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      open();
      return;
    }
    if (!modal || modal.hidden) return;
    var t = e.target;
    if (t.closest && t.closest('[data-ils-chat-ok]')) {
      e.preventDefault();
      close();
    }
  });
})();
